export const HomePage = () => {
    return <p>Home page</p>
}
